import { ApiError, Game } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { GameAction, GameActionTypes } from "./Game";
import { getGame as apiGetGame } from "@blacknut/javascript-sdk/dist/api/getGame";
const fetchGameRequest = (id: string): GameAction => ({
  type: GameActionTypes.GAME_FETCH_REQUEST,
  id,
});

export const fetchGameSuccess = (game: Game): GameAction => ({
  type: GameActionTypes.GAME_FETCH_SUCCESS,
  game,
});

const fetchGameError = (id: string, error?: ApiError): GameAction => ({
  type: GameActionTypes.GAME_FETCH_ERROR,
  id,
  error,
});

export const dismissGameError = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    dispatch(fetchGameError(id));
  };
};

// fetch game without triggering 'loading' nor error
export const silentFetchGame = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    return new Promise<Game>((resolve, reject) => {
      apiGetGame(id).subscribe({
        next: (res) => {
          dispatch(fetchGameSuccess(res));
          resolve(res);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  };
};

export const fetchGame = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    return new Promise<Game>((resolve, reject) => {
      dispatch(fetchGameRequest(id));
      apiGetGame(id).subscribe({
        next: (res) => {
          dispatch(fetchGameSuccess(res));
          resolve(res);
        },
        error: (error) => {
          dispatch(fetchGameError(id, error));
          reject(error);
        },
      });
    });
  };
};
